import React, { Component } from 'react'
import './Bloc.css'

class BlocErreur extends Component {
    render() {
        const style = {}
        style.display = 'table'
        style.width = '80%'
        style.marginLeft = '10%'
        style.marginRight = '10%'
        style.borderRadius = '20px'

        if (this.props.height && this.props.height !== undefined) {
            style.minHeight = this.props.height + 'px'
        } else {
            style.minHeight = '25px'
        }

        return (
            <div>
                <div className="Bloc fade-in bloc-full" style={style}>
                    <div className="textErreur semibold-font">
                        {this.props.label}
                    </div>
                </div>
            </div>
        )
    }
}

export default BlocErreur
